import { render, staticRenderFns } from "./AddSchoolModal.vue?vue&type=template&id=1377a5f7&"
import script from "./AddSchoolModal.vue?vue&type=script&lang=js&"
export * from "./AddSchoolModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSchoolModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports